<button
  mat-button
  type="button"
  class="qaroni-close-icon"
  [mat-dialog-close]="false">
  <mat-icon>close</mat-icon>
</button>

@if (hasHistory) {
  <qaroni-title-subtitle>
    <ng-container title i18n>Historial de cambios</ng-container>
    <ng-container subtitle>
      <ng-container i18n>Fichaje: </ng-container
      ><strong>{{ checkDate }}</strong>
    </ng-container>
  </qaroni-title-subtitle>
}

<form autocomplete="off" class="flex w-full flex-col">
  <mat-dialog-content class="py-0">
    @if (type === 'company') {
      @if (scheduleCheck$ | async) {
        @if (hasHistory) {
        } @else {
          <div
            class="flex h-64 flex-col items-center justify-center gap-3 text-gray-500">
            <mat-icon class="!h-10 !w-10 text-[40px] text-gray-300"
              >history_toggle_off</mat-icon
            >
            <p class="text-center font-medium" i18n>
              No hay historial de cambios
            </p>
          </div>
        }
      } @else {
        <qaroni-loading [height]="212" />
      }
    } @else {
      @if (check$ | async) {
        @if (hasHistory) {
        } @else {
          <div
            class="flex h-64 flex-col items-center justify-center gap-3 text-gray-500">
            <mat-icon class="!h-10 !w-10 text-[40px] text-gray-300"
              >history_toggle_off</mat-icon
            >
            <p class="text-center font-medium" i18n>
              No hay historial de cambios
            </p>
          </div>
        }
      } @else {
        <qaroni-loading [height]="212" />
      }
    }

    @if (hasHistory) {
      <div class="w-full text-left text-sm text-gray-600">
        <div
          class="grid grid-cols-[50px_1fr_90px_24px] border-b border-gray-200 bg-gray-50 px-2 py-3 text-xs font-medium text-gray-900 md:grid-cols-[60px_1fr_90px_30px] md:px-4 md:text-sm">
          <span i18n>Fecha</span>
          <span i18n>Usuario/Canal</span>
          <span i18n>Cambios</span>
          <span></span>
        </div>

        <div class="divide-y divide-gray-200">
          @for (check of checkHistoryList; track check.historyId) {
            <div class="flex flex-col bg-white">
              <div
                role="button"
                tabindex="0"
                (click)="
                  hasDetails(check) ? toggleExpand(check.historyId) : null
                "
                (keydown.enter)="
                  hasDetails(check) ? toggleExpand(check.historyId) : null
                "
                (keydown.space)="
                  hasDetails(check) ? toggleExpand(check.historyId) : null
                "
                [ngClass]="{
                  'cursor-pointer hover:bg-gray-50': hasDetails(check),
                  'cursor-default': !hasDetails(check),
                }"
                class="group grid grid-cols-[50px_1fr_90px_24px] items-center gap-1 px-2 py-3 transition-colors md:grid-cols-[60px_1fr_90px_30px] md:gap-2 md:px-4">
                <div class="flex flex-col text-xs md:text-sm">
                  <span>
                    {{ check.creationDate | date: 'dd/MMM' }}
                  </span>
                  <span class="text-gray-500">
                    {{ check.creationDate | date: 'shortTime' }}
                  </span>
                </div>

                <div class="flex flex-col gap-1">
                  @if (!isWorkstationCheck(check.type)) {
                    <span class="break-words text-xs leading-tight md:text-sm">
                      {{ check.user.fullName }}
                    </span>
                  }
                  <div class="flex flex-wrap items-center gap-1">
                    @if (check.action) {
                      <span
                        class="inline-flex w-fit items-center gap-1 rounded border border-gray-200 bg-gray-100 px-1.5 py-0.5 text-xs">
                        <mat-icon
                          class="qaroni-mat-icon-14 material-symbols-outlined h-4 w-4 shrink-0"
                          >{{ getIconActionType(check.action) }}</mat-icon
                        >
                        <span class="text-xs">{{
                          check.action | checksActionsName
                        }}</span>
                      </span>
                    }
                    <span
                      class="inline-flex w-fit items-center gap-1 rounded border border-gray-200 bg-gray-100 px-1.5 py-0.5 text-xs">
                      <mat-icon class="qaroni-mat-icon-14 h-4 w-4 shrink-0">{{
                        getIconDeviceType(check.type)
                      }}</mat-icon>
                      <span class="text-xs">{{
                        check.type | checksTypeName
                      }}</span>
                    </span>
                  </div>
                </div>

                <div class="flex flex-col text-xs md:text-sm">
                  @if (check.oldStartDate) {
                    <span class="mb-0.5 text-gray-400 line-through">
                      {{ check.oldStartDate | date: 'shortTime' }}
                      @if (check.oldEndDate) {
                        - {{ check.oldEndDate | date: 'shortTime' }}
                      }
                    </span>
                  }
                  <div class="flex items-center">
                    <span>{{ check.newStartDate | date: 'shortTime' }}</span>
                    @if (check.newEndDate) {
                      <span class="mx-1 text-gray-400">-</span>
                      <span>{{ check.newEndDate | date: 'shortTime' }}</span>
                    }
                  </div>
                </div>

                <div
                  class="flex justify-end text-gray-400 group-hover:text-gray-600">
                  @if (hasDetails(check)) {
                    <mat-icon
                      class="transition-transform duration-200"
                      [class.rotate-180]="
                        expandedHistoryId === check.historyId
                      ">
                      keyboard_arrow_down
                    </mat-icon>
                  }
                </div>
              </div>
              @if (hasDetails(check) && expandedHistoryId === check.historyId) {
                <div
                  class="animate-fadeIn border-t border-gray-100 bg-gray-50 p-4">
                  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <div class="flex flex-col gap-3">
                      @if (check?.ip) {
                        <div class="flex flex-col gap-1 text-xs">
                          <span
                            class="text-xs font-semibold uppercase tracking-wide text-gray-500"
                            >Dirección IP</span
                          >
                          <div class="flex items-center gap-2 text-gray-700">
                            <mat-icon
                              class="qaroni-mat-icon-16 h-4 w-4 leading-4 text-primary-40"
                              >dns</mat-icon
                            >
                            <span class="font-mono">{{ check?.ip }}</span>
                          </div>
                        </div>
                      }

                      @if (check.comment) {
                        <div class="mt-1 flex flex-col gap-1 text-xs">
                          <span
                            class="text-xs font-semibold uppercase tracking-wide text-gray-500"
                            >Comentario</span
                          >
                          <div class="flex items-start text-gray-500">
                            <span class="italic leading-snug">{{
                              check.comment
                            }}</span>
                          </div>
                        </div>
                      }
                    </div>

                    @if (hasValidLocation(check)) {
                      <div
                        class="relative h-32 overflow-hidden rounded-lg border border-gray-200 shadow-sm">
                        <google-map
                          [center]="getMapPosition(check)"
                          [zoom]="15"
                          height="100%"
                          width="100%"
                          [options]="mapOptions">
                          <map-marker [position]="getMapPosition(check)" />
                        </google-map>
                      </div>
                    } @else {
                      <div
                        class="flex h-32 flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-100 text-xs text-gray-400">
                        <mat-icon class="qaroni-mat-icon-20 mb-1 h-5 w-5"
                          >location_off</mat-icon
                        >
                        <span>Ubicación no disponible</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions
    align="center"
    class="mt-auto border-t border-gray-100 !pb-6 !pt-4">
    @if ((scheduleCheck$ | async) || (check$ | async)) {
      <button
        mat-flat-button
        color="blue"
        class="qaroni-rounded-button"
        [mat-dialog-close]="false"
        type="button">
        <mat-icon class="me-1">check</mat-icon>
        <ng-container i18n>Aceptar</ng-container>
      </button>
    }
  </mat-dialog-actions>
</form>
